import { render } from "./UserModal.vue?vue&type=template&id=6f6c0e92&ts=true"
import script from "./UserModal.vue?vue&type=script&lang=ts"
export * from "./UserModal.vue?vue&type=script&lang=ts"

import "./UserModal.vue?vue&type=style&index=0&id=6f6c0e92&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__